import { render, staticRenderFns } from "./AgentTransactions.vue?vue&type=template&id=55053739"
import script from "./AgentTransactions.vue?vue&type=script&lang=js"
export * from "./AgentTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports